import { PaymentProcessorEnum } from '@systemeio/ui'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { GOCARDLESS_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/gocardless/api'
import {
  GocardlessAuthorizationLinkPayloadInterface,
  GocardlessCreateIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/gocardless/types'
import Router, { useRouter } from 'next/router'
import { useEffect } from 'react'
import { BASE_PATH_URL } from 'shared/constants/base-path-url'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

const getRedirectUrl = (pathname: string) => `${window.location.origin}${BASE_PATH_URL}${pathname}`

export const useGoCardlessConnect = () => {
  const { pathname, query } = useRouter()
  const { code: goCardlessConnectCode } = query

  const { paymentIntegrations, mutatePaymentIntegrations, getConnectedPaymentIntegration } =
    useConnectedPaymentIntegrations()

  const { fetcher: authFetcher } = useFetch<
    RequestMethodsEnum.post,
    { authenticationUrl?: string },
    GocardlessAuthorizationLinkPayloadInterface
  >({ method: RequestMethodsEnum.post })

  const { fetcher: connectFetcher } = useFetch({
    method: RequestMethodsEnum.post,
  })

  const getGoCardlessAuthorizationLink = async () => {
    try {
      const responseData = await authFetcher(`${GOCARDLESS_ACCOUNT_API}/authorization-link`, {
        redirectUrl: getRedirectUrl(pathname),
      } as GocardlessAuthorizationLinkPayloadInterface)
      if (responseData.authenticationUrl) {
        window.open(responseData.authenticationUrl, '_self')
      }
    } catch (e) {}
  }
  useEffect(() => {
    if (!goCardlessConnectCode || !paymentIntegrations) return

    const gocardlessIntegration = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.Gocardless,
    })
    const connectGoCardlessAccount = async () => {
      try {
        await connectFetcher(`${GOCARDLESS_ACCOUNT_API}/create`, {
          authorizationCode: goCardlessConnectCode,
          redirectUrl: getRedirectUrl(pathname),
        } as GocardlessCreateIntegrationInterface)
        await Router.replace({ pathname }, undefined, { shallow: true })
        await mutatePaymentIntegrations()
      } catch (e) {}
    }

    if (!gocardlessIntegration) {
      connectGoCardlessAccount()
    }
  }, [
    connectFetcher,
    goCardlessConnectCode,
    mutatePaymentIntegrations,
    pathname,
    paymentIntegrations,
  ])

  return { getGoCardlessAuthorizationLink }
}
